module.exports = __webpack_public_path__ + "assets/img/range2.ae30a8d4.png";